export default __webpack_public_path__ + "static/media/filling_6.c02d4100.jpg";